/* eslint-disable no-console */

const routes = {
  //ADMIN
  ADMIN: {
    path: '/admin',
    to: '/admin',
    relative: false,
  },
  ORGANIZATION: {
    path: 'organization',
    to: '/organization',
    relative: false,
  },
  AGREEMENTS: {
    path: 'organizations/:organizationId/agreements',
    to: '/agreements',
    relative: false,
  },
  USERS: {
    path: 'users',
    to: '/users',
    relative: false,
  },
  LIVE_DEPLOYMENT: {
    path: 'livedeployments',
    to: '/livedeployments',
    relative: false,
  },
  LIVE_SETTINGS_EDIT: {
    path: 'edit/:id',
    to: '/edit',
    relative: true,
  },
  LIVE_SETTINGS_NEW: {
    path: ':id',
    to: '/new',
    relative: true,
  },
  LIVE_SETTINGS: {
    path: 'livesettings',
    to: '/livesettings',
    relative: false,
  },
  ORIGINS: {
    path: 'origins',
    to: '/origins',
    relative: false,
  },
  ORIGIN_NEW: {
    path: ':id',
    to: '/new',
    relative: true,
  },
  ORIGIN_EDIT: {
    path: 'edit/:id',
    to: '/edit',
    relative: true,
  },
  TAG_MANAGER: {
    path: 'tagmanager',
    to: '/tagmanager',
    relative: false,
  },
  TAG_MANAGER_NEW: {
    path: ':id',
    to: '/new',
    relative: true,
  },
  TAG_MANAGER_EDIT: {
    path: 'edit/:id',
    to: '/edit',
    relative: true,
  },
  AUDIT: {
    path: 'audit',
    to: '/audit',
    relative: false,
  },

  //ASSET MANAGER
  VIDEO_MANAGER: {
    path: '/assetsmanager',
    to: '/assetsmanager',

    relative: false,
  },
  VOD: {
    path: 'vod',
    to: '/assetsmanager/vod',
    relative: false,
  },
  VOD_NEW: {
    path: ':id',
    to: '/new',
    relative: true,
  },
  VOD_EDIT: {
    path: 'edit/:id',
    to: '/edit',
    relative: true,
  },
  VODGRAPHICMANAGER: {
    path: 'vodgraphicmanager',
    to: '/assetsmanager/vodgraphicmanager',
    relative: false,
  },
  VODGRAPHICMANAGER_NEW: {
    path: ':id',
    to: '/new',
    relative: true,
  },
  VODGRAPHICMANAGER_EDIT: {
    path: 'edit/:id',
    to: '/edit',
    relative: true,
  },
  LIVE_GRAPHICMANAGER: {
    path: 'graphicmanagers',
    to: '/assetsmanager/graphicmanagers',
    relative: false,
  },
  LIVE_GRAPHICMANAGER_EDIT: {
    path: 'graphicmanagers/edit/:id',
    to: '/assetsmanager/graphicmanagers/edit',
    relative: false,
  },
  LIVE_GRAPHICMANAGER_RUN: {
    path: 'graphicmanagers/run/:id',
    to: '/assetsmanager/graphicmanagers/run',
    relative: false,
  },
  COMPOSE_EXPERIENCE: {
    path: 'composeexperience',
    to: '/assetsmanager/composeexperience',
    relative: false,
  },
  COMPOSE_EXPERIENCE_NEW: {
    path: ':id',
    to: '/new',
    relative: true,
  },
  COMPOSE_EXPERIENCE_EDIT: {
    path: 'edit/:id',
    to: '/edit',
    relative: true,
  },

  LIVE: {
    path: 'lives',
    to: '/assetsmanager/lives',
    relative: false,
  },
  LIVE_NEW: {
    path: ':id',
    to: '/new',
    relative: true,
  },
  LIVE_EDIT: {
    path: 'edit/:id',
    to: '/edit',
    relative: true,
  },
  LIVE_LOG: {
    path: 'log/:id',
    to: '/log',
    relative: true,
  },
  LIVE_APPS: {
    path: 'apps/:id',
    to: '/apps',
    relative: true,
  },
  LIVETEMPLATE: {
    path: 'livetemplates',
    to: '/assetsmanager/livetemplates',
    relative: false,
  },
  LIVETEMPLATE_NEW: {
    path: ':id',
    to: '/new',
    relative: true,
  },
  LIVETEMPLATE_EDIT: {
    path: 'edit/:id',
    to: '/edit',
    relative: true,
  },
  INGEST_SERVER: {
    path: 'ingestservers',
    to: '/assetsmanager/ingestservers',
    relative: false,
  },
  INGEST_SERVER_NEW: {
    path: ':id',
    to: '/new',
    relative: true,
  },
  INGEST_SERVER_EDIT: {
    path: 'edit/:id',
    to: '/edit',
    relative: true,
  },
  LIVE_SCHEDULED: {
    path: 'liveScheduled',
    to: '/assetsmanager/liveScheduled',
    relative: false,
  },
  SPONSORS: {
    path: 'sponsors',
    to: '/assetsmanager/sponsors',
    relative: false,
  },
  SPONSORS_NEW: {
    path: ':id',
    to: '/new',
    relative: true,
  },
  SPONSORS_EDIT: {
    path: 'edit/:id',
    to: '/edit',
    relative: true,
  },

  //SCOREBOARD
  SCOREBOARD: {
    path: '/scoreboard',
    to: '/scoreboard',
    relative: false,
  },
  //DEBUG
  DEBUG: {
    path: '/debug',
    to: '/debug',
    relative: false,
  },
  WEBSOCKETS: {
    path: 'websockets',
    to: '/debug/websockets',
    relative: true,
  },
  NBASCOREBOARDS: {
    path: 'nba-scoreboards',
    to: '/debug/nba-scoreboards',
    relative: true,
  },
  NASCARSCOREBOARDS: {
    path: 'nascar-scoreboards',
    to: '/debug/nascar-scoreboards',
    relative: true,
  },
  //CLIENT PORTAL
  BILLING_TRANSACTIONS_SUMMARY: {
    path: 'billingTransactionsSummary',
    to: '/billingTransactionsSummary',
    relative: true,
  },
  BILLING_TRANSACTIONS_DETAIL: {
    path: 'billingTransactionDetail/:id',
    to: '/billingTransactionDetail',
    relative: true,
  },
  BILLING_TRANSACTIONS_SUMMARY_DIRECT: {
    path: 'billingTransactionsSummary',
    to: '/clientPortal/billingTransactionsSummary',
    relative: false,
  },

  LOGIN: {
    path: '/login',
    to: '/login',
    relative: false,
  },
  HOME_PAGE: {
    path: '/home',
    to: '/home',
    relative: false,
  },

  APP_MANAGER: {
    path: 'wlplay/:appSlug?',
    to: '/wlplay',
    relative: false,
  },
  SCHEDULE: {
    path: '/schedule',
    to: '/schedule',
    relative: false,
  },
  PAIRING_START: {
    path: 'pairing/device',
    to: '/pairing/device',
    relative: false,
  },
  FAVORITES_IG: {
    path: 'favorites-ig',
    to: '/favorites-ig',
    relative: false,
  },

  PAIRING_CODE: {
    path: 'pairing/device/code',
    to: '/pairing/device/code',
    relative: false,
  },
  SPACES_MAP: {
    path: '/spaces_map/:configId?',
    to: '/spaces_map',
    relative: true,
  },
  // MH_CANVAS: {
  //   path: '/mh_canvas/:configId?',
  //   to: '/mh_canvas',
  //   relative: true,
  // },
  MH_CLIENT_CONFIG: {
    path: 'mhClientConfig/:configId?',
    to: '/mhClientConfig',
    relative: true,
  },
  YOUTUBE: {
    path: '/youtube/:configId?',
    to: '/youtube',
    relative: true,
  },

  YOUTUBE_CATEGORIES_EDIT: {
    path: '/youtube/categories/:categoryId',
    to: '',
    relative: true,
  },
  YOUTUBE_CATEGORIES: {
    path: '/youtube/categories',
    to: '/youtube/categories',
    relative: true,
  },
  YOUTUBE_CATEGORIES_NEW: {
    path: '/youtube/categories/:new',
    to: '/new',
    relative: true,
  },
  YOUTUBE_INTERACTABLES_EDIT: {
    path: 'interactables/:interactableId',
    to: '',
    relative: true,
  },

  YOUTUBE_INTERACTABLES: {
    path: '/youtube/interactables',
    to: '/youtube/interactables',
    relative: true,
  },
  YOUTUBE_INTERACTABLES_NEW: {
    path: '/youtube/interactables/:new',
    to: '/new',
    relative: true,
  },
  SPORT_ROOM: {
    path: '/wlpro/:mainHubSlugName/space/:spaceSlugName',
    to: '/wlpro/mainHubSlugName',
    relative: false,
  },
   SPORT_ROOM_HOME_MAINHUB: {
    path: '/wlpro/:mainHubSlugName/space/:id/home',
    to: '/wlpro/mainHubSlugName/space/id/home',
    relative: false,
  },
  MAIN_HUBS: {
    path: '/wlpro',
    to: '/wlpro',
    relative: false,
  },
  MAIN_HUB: {
    path: '/wlpro/:mainHubSlugName',
    to: '/wlpro',
    relative: false,
  },
  MAIN_HUB_HOME: {
    path: '/wlpro/:mainHubSlugName?/home',
    to: '/wlpro',
    relative: false,
  },
  SPORT_ROOM_HOME: {
    path: '/space/:spaceSlugName?/home',
    to: '/space',
    relative: false,
  },
  MAIN_HUB_XTADIUM: {
    path: '/wlpro/:mainHubSlugName?',
    to: '/wlpro/xstadium',
    relative: false,
  },
  CLIENT_PORTAL: {
    path: '/clientPortal',
    to: '/clientPortal',
    relative: false,
  },

  APPEARANCE: {
    path: 'appearance/:appConfigSlug?',
    to: '/appearance',
    relative: true,
  },
  APP_CANVAS: {
    path: '/canvas/:appConfigSlug?',
    to: '/canvas',
    relative: true,
  },
  APP_LAYOUT: {
    path: 'layout/:appConfigSlug?',
    to: '/layout',
    relative: true,
  },
  APP_CONFIG: {
    path: '/config/:appConfigSlug?',
    to: '/config',
    relative: true,
  },
  TAGS: {
    path: '/tags',
    to: '/tags',
    relative: true,
  },
  APP_HOME: {
    path: '/home/:appConfigSlug?',
    to: '/home',
    relative: true,
  },
  APP_CUSTOMIZATION: {
    path: 'customization/:appConfigSlug?',
    to: '/customization',
    relative: true,
  },
  CATEGORIES: {
    path: 'categories/:appConfigSlug?',
    to: '/categories',
    relative: true,
  },
  INFO_SECTION: {
    path: 'info/:appConfigSlug?',
    to: '/info',
    relative: true,
  },
  INFO_SECTION_WHITE_LABEL_PRO: {
    path: '/info/:mainHubConfigId?',
    to: '/info',
    relative: true,
  },
  INFO_SECTION_WHITE_LABEL_PRO: {
    path: '/info/:mainHubConfigId?',
    to: '/info',
    relative: true,
  },
  DOMAINS: {
    path: 'domains/:appConfigSlug?',
    to: '/domains',
    relative: true,
  },
  APP_DICTIONARY: {
    path: 'dictionary',
    to: '/dictionary',
    relative: true,
  },
  APP_FEEDBACK: {
    path: 'feedback',
    to: '/feedback',
    relative: true,
  },
  APP_TRANSACTIONS: {
    path: 'transactions',
    to: '/transactions',
    relative: true,
  },
  APP_PROVIDERS: {
    path: 'providers',
    to: '/providers',
    relative: true,
  },
  APP_DYNAMIC_PROVIDERS: {
    path: 'dynamicProviders',
    to: '/dynamicProviders',
    relative: true,
  },
  APP_DYNAMIC_NEW: {
    path: 'dynamicProviders/new',
    to: '/new',
    relative: true,
  },
  APP_DYNAMIC_EDIT: {
    path: 'dynamicProviders/:providerId',
    to: '',
    relative: true,
  },
  APP_DYNAMIC_TOKENS: {
    path: 'dynamicProviders/:providerId/tokens',
    to: '',
    relative: true,
  },
  APP_BLACKOUT_EDIT: {
    path: 'blackouts/:blackoutId',
    to: '',
    relative: true,
  },
  APP_BLACKOUTS: {
    path: 'blackouts',
    to: '/blackouts',
    relative: true,
  },
  APP_BLACKOUT_NEW: {
    path: 'blackouts/:blackoutId/new',
    to: 'new',
    relative: true,
  },
  POSTAL_GROUPS_EDIT: {
    path: 'postalgroups/:groupId',
    to: '',
    relative: true,
  },
  POSTAL_GROUPS: {
    path: 'postalgroups',
    to: '/postalgroups',
    relative: true,
  },
  POSTAL_GROUPS_NEW: {
    path: 'postalgroups/:groupId',
    to: 'new',
    relative: false,
  },


  APP_SKUs: {
    path: '/skus',
    to: '/skus',
    relative: true,
  },
  APP_THIRD_PARTY: {
    path: '/thirdPartyAuth',
    to: '/thirdPartyAuth',
    relative: true,
  },
  APP_PROVIDER_EDIT: {
    path: 'providers/:providerId',
    to: '',
    relative: true,
  },
  APP_CONTENT: {
    path: 'content/:appConfigSlug?',
    to: '/content',
    relative: true,
  },
  APP_CONTENT_NEW: {
    path: 'content/:appConfigSlug',
    to: '/new',
    relative: true,
  },
  APP_CONTENT_EDIT: {
    path: 'content/:appConfigSlug/:contentId',
    to: '',
    relative: true,
  },
  VIDEO_CONTENT: {
    path: 'videocontent/:appConfigSlug?',
    to: '/videocontent',
    relative: true,
  },
  VIDEO_CONTENT_VIDEO: {
    path: 'videocontentvideo/:id?/:videoContentSidePanelId?',
    to: '/videocontentvideo',
    relative: true,
  },
  TEST: {
    path: '/test',
    to: '/test',
    relative: true,
  },
  VIDEO_MANAGER: {
    path: '/assetsmanager',
    to: '/assetsmanager',

    relative: false,
  },
  SCOREBOARD: {
    path: '/scoreboard',
    to: '/scoreboard',

    relative: false,
  },
  VOD: {
    path: '/assetsmanager/vod',
    to: '/assetsmanager/vod',
    relative: false,
  },
  VOD_NEW: {
    path: '/assetsmanager/vod/:id',
    to: '/assetsmanager/vod/new',
    relative: false,
  },
  VOD_EDIT: {
    path: '/assetsmanager/vod/edit/:id',
    to: '/assetsmanager/vod/edit',
    relative: false,
  },
  VOD_TEMPLATE: {
    path: '/assetsmanager/vod-templates',
    to: '/assetsmanager/vod-templates',
    relative: false,
  },
  VOD_TEMPLATE_EDIT: {
    path: '/assetsmanager/vod-template/edit/:id',
    to: '/assetsmanager/vod-template/edit',
    relative: false,
  },
  VODGRAPHICMANAGER: {
    path: '/assetsmanager/vodgraphicmanager',
    to: '/assetsmanager/vodgraphicmanager',
    relative: false,
  },
  VODGRAPHICMANAGER_NEW: {
    path: '/assetsmanager/vodgraphicmanager/:id',
    to: '/assetsmanager/vodgraphicmanager/new',
    relative: false,
  },
  VODGRAPHICMANAGER_EDIT: {
    path: '/assetsmanager/vodgraphicmanager/edit/:id',
    to: '/assetsmanager/vodgraphicmanager/edit',
    relative: false,
  },
  LIVE: {
    path: '/assetsmanager/lives',
    to: '/assetsmanager/lives',
    relative: false,
  },
  LIVE_NEW: {
    path: '/assetsmanager/lives/:id',
    to: '/assetsmanager/lives/new',
    relative: false,
  },
  LIVE_LOG: {
    path: '/assetsmanager/lives/log/:id',
    to: '/assetsmanager/lives/log',
    relative: false,
  },
  LIVE_EDIT: {
    path: '/assetsmanager/lives/edit/:id',
    to: '/assetsmanager/lives/edit',
    relative: false,
  },
  LIVE_APPS: {
    path: '/assetsmanager/lives/apps/:id',
    to: '/assetsmanager/lives/apps',
    relative: false,
  },
  LIVE_GRAPHICMANAGER_EDIT: {
    path: '/assetsmanager/graphicmanagers/edit/:id',
    to: '/assetsmanager/graphicmanagers/edit',
    relative: false,
  },
  LIVE_GRAPHICMANAGER_RUN: {
    path: '/assetsmanager/graphicmanagers/run/:id',
    to: '/assetsmanager/graphicmanagers/run',
    relative: false,
  },

  LIVE_GRAPHICMANAGER: {
    path: '/assetsmanager/graphicmanagers',
    to: '/assetsmanager/graphicmanagers',
    relative: false,
  },
  LIVETEMPLATE: {
    path: '/assetsmanager/livetemplates',
    to: '/assetsmanager/livetemplates',
    relative: false,
  },
  LIVETEMPLATE_NEW: {
    path: '/assetsmanager/livetemplates/:id',
    to: '/assetsmanager/livetemplates/new',
    relative: false,
  },
  LIVETEMPLATE_EDIT: {
    path: '/assetsmanager/livetemplates/edit/:id',
    to: '/assetsmanager/livetemplates/edit',
    relative: false,
  },
  INGEST_SERVER_NEW: {
    path: '/assetsmanager/ingestserver/:id',
    to: '/assetsmanager/ingestserver/new',
    relative: false,
  },
  LIVE_SCHEDULED: {
    path: '/assetsmanager/liveScheduled',
    to: '/assetsmanager/liveScheduled',
    relative: false,
  },
  SPONSORS: {
    path: '/assetsmanager/sponsors',
    to: '/assetsmanager/sponsors',
    relative: false,
  },

  SPONSORS_NEW: {
    path: '/assetsmanager/sponsors/new',
    to: '/assetsmanager/sponsors/new',
    relative: false,
  },

  SPONSORS_EDIT: {
    path: '/assetsmanager/sponsors/edit/:id',
    to: '/assetsmanager/sponsors/edit',
    relative: false,
  },

  INGEST_SERVER_EDIT: {
    path: '/assetsmanager/ingestserver/edit/:id',
    to: '/assetsmanager/ingestserver/edit',
    relative: false,
  },
  INGEST_SERVER: {
    path: '/assetsmanager/ingestservers',
    to: '/assetsmanager/ingestservers',
    relative: false,
  },
  COMPOSE_EXPERIENCE: {
    path: '/assetsmanager/composeexperience',
    to: '/assetsmanager/composeexperience',
    relative: false,
  },
  COMPOSE_EXPERIENCE_NEW: {
    path: '/assetsmanager/composeexperience/:id',
    to: '/assetsmanager/composeexperience/new',
    relative: false,
  },
  COMPOSE_EXPERIENCE_EDIT: {
    path: '/assetsmanager/composeexperience/edit/:id',
    to: '/assetsmanager/composeexperience/edit',
    relative: false,
  },
  USERS_EDIT: {
    path: '/users/edit/:id',
    to: 'edit',
    relative: false,
  },
  USERS_NEW: {
    path: '/users/:id',
    to: '/new',
    relative: false,
  },

  ADMIN: {
    path: '/admin',
    to: '/admin',
    relative: false,
  },
  DEBUG: {
    path: '/debug',
    to: '/debug',
    relative: false,
  },
  ROLES: {
    path: '/roles',
    to: '/roles',
    relative: false,
  },
  ROLES_EDIT: {
    path: '/roles/edit/:id',
    to: '/roles/edit',
    relative: false,
  },
  CONFIG_EDIT: {
    path: 'configs/edit/:configId',
    to: '/edit',
    relative: true,
  },
  CONFIG: {
    path: 'configs',
    to: 'configs',
    relative: false,
  },
  CONFIG_NEW: {
    path: 'configs/new',
    to: '/new',
    relative: true,
  },
  CONFIG_RULES: {
    path: 'configs/rules/:configId',
    to: '/rules',
    relative: true,
  },
  CLIENT_CONFIG: {
    path: 'clientConfig/:appConfigSlug?',
    to: '/clientConfig',
    relative: true,
  },

  MH_CONFIG_EDIT: {
    path: '/configs/edit/:id',
    to: '/edit',
    relative: true,
  },
  MAIN_HUB_THIRD_PARTY: {
    path: 'providers/thirdPartys',
    to: '/providers/thirdPartys',
    relative: true,
  },
  MAIN_HUB_THIRD_PARTY_EDIT: {
    path: 'providers/thirdPartys/:id',
    to: '',
    relative: true,
  },
  MAIN_HUB_THIRD_PARTY_NEW: {
    path: 'providers/thirdPartys/new',
    to: '/new',
    relative: true,
  },
  MH_CONFIG_RULES: {
    path: 'configs/rules/:configId',
    to: '/rules',
    relative: true,
  },
  MH_CONFIG_NEW: {
    path: '/configs/new',
    to: '/new',
    relative: true,
  },
  APP_TAGS_EDIT: {
    path: '/tags/:id',
    to: '',
    relative: true,
  },
  APP_TAGS_WHITE_LABEL_NEW: {
    path: 'tags/new',
    to: '/new',
    relative: true,
  },
  APP_TAGS_WHITE_LABEL_EDIT: {
    path: 'tags/edit/:id',
    to: '/edit',
    relative: true,
  },
  APP_TAGS_WHITE_LABEL: {
    path: 'tags',
    to: '/tags',
    relative: true,
  },
  MH_CONFIG: {
    path: '/configs',
    to: '/configs',
    relative: true,
  },
  MH_CUSTOMIZATION: {
    path: '/customization',
    to: '/customization',
    relative: true,
  },
  MH_GENERAL_SETTINGS: {
    path: '/generalSettings',
    to: '/generalSettings',
    relative: true,
  },
  MH_SPORTROOM: {
    path: ':mainHubId/space',
    to: '/space',
    relative: true,
  },
  APP_TEAMS_BLACKOUTS: {
    path: '/space/:appId/teamblackouts/:teamId',
    to: '/space/teamblackouts',
    relative: false,
  },
  DEVICES: {
    path: 'devices',
    to: '/devices',
    relative: false,
  },
  DEVICES_EDIT: {
    path: '/devices/edit/:id',
    to: 'edit',
    relative: false,
  },
  DEVICES_NEW: {
    path: 'devices/:id',
    to: 'new',
    relative: false,
  },
  DEVICE_TYPES: {
    path: 'device-types',
    to: '/device-types',
    relative: false,
  },
  LANGUAGES: {
    path: 'languages',
    to: '/languages',
    relative: false,
  },
  CREDENTIAL: {
    path: 'tokens',
    to: '/tokens',
    relative: false,
  },
  CREDENTIAL_KEY: {
    path: 'key',
    to: '/key',
    relative: false,
  },
  CREDENTIAL_KEY_TOKENS: {
    path: 'key/:id/tokens',
    to: '/key',
    relative: false,
  },
  CREDENTIAL_KEY_NEW: {
    path: 'key/:id',
    to: 'new',
    relative: false,
  },
  CREDENTIAL_KEY_EDIT: {
    path: 'key/:id',
    to: 'edit',
    relative: false,
  },
};

export const getRoute = (routeSelected, currentPath, param = undefined) => {
  try {
    let url = routeSelected.path;
    if (routeSelected.relative) {
      if (currentPath === undefined) {
        url = param ? `/${param}` + routeSelected.path : routeSelected.path;
      } else {
        url = param ? currentPath + `/${param}` + routeSelected.path : currentPath + routeSelected.path;
      }
    }
    return url;
  } catch (e) {
    console.error('The parameter must be a routes object');
  }
  return null;
};

export const getLink = (routeSelected, currentPath, param = undefined, param2 = undefined) => {
  try {
    let url = routeSelected.to === undefined ? currentPath : routeSelected.to;
    if (routeSelected.relative) {
      url = param2 ? currentPath + `/${param2}` + routeSelected.to : currentPath + routeSelected.to;
    }
    if (param !== undefined) {
      url = `${url}/${param}`;
    }
    return url;
  } catch (e) {
    console.error('The parameter must be a routes object');
    console.log(e);
  }

  return null;
};

export const goTo = (routeSelected, ...params) => {
  try {
    const base = routeSelected?.to ?? '';

    const cleanParts = [base, ...params]
      .filter((part) => part !== undefined && part !== null && part !== '')
      .map((part) => String(part).replace(/^\/+|\/+$/g, ''));

    return cleanParts.join('/');
  } catch (e) {
    console.error('The parameter must be a routes object', e);
    return '';
  }
};


export default routes;
